var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58432",
    "data-name": "Group 58432",
    transform: "translate(-532 -94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7987",
    "data-name": "Rectangle 7987",
    width: 70,
    height: 70,
    rx: 17,
    transform: "translate(532 94)",
    fill: "#f5fbfa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58430",
    "data-name": "Group 58430",
    transform: "translate(-392.5 -329.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58424",
    "data-name": "Group 58424",
    transform: "translate(937.5 435.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42360",
    "data-name": "Path 42360",
    d: "M54.617,240.5h-42c-.4,0-.73.142-.73.317v.423c0,.175.327.317.73.317h42c.4,0,.73-.142.73-.317v-.423c0-.175-.327-.317-.73-.317Z",
    transform: "translate(-11.885 -195.49)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42361",
    "data-name": "Path 42361",
    d: "M159.144,1.154A1.457,1.457,0,0,1,157.967.02c0-.026-.053-.026-.053,0a1.457,1.457,0,0,1-1.16,1.151c-.026,0-.026.04,0,.053a1.457,1.457,0,0,1,1.177,1.134c0,.026.053.026.053,0a1.457,1.457,0,0,1,1.16-1.151c.026-.013.026-.053,0-.053Z",
    transform: "translate(-129.626 -0.001)",
    fill: "#70d6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42362",
    "data-name": "Path 42362",
    d: "M215.258,166.961h-.43v-.43a.6.6,0,0,0-.6-.6.591.591,0,0,0-.6.6v.43h-.43a.6.6,0,0,0-.6.6.591.591,0,0,0,.6.6h.43v.43a.6.6,0,0,0,.6.6.591.591,0,0,0,.6-.6v-.43h.43a.6.6,0,0,0,.6-.6A.591.591,0,0,0,215.258,166.961Z",
    transform: "translate(-175.036 -134.878)",
    fill: "#fc657e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42363",
    "data-name": "Path 42363",
    d: "M45.884,65.988a2.077,2.077,0,0,1-1.666-1.628c0-.037-.075-.037-.075,0a2.077,2.077,0,0,1-1.666,1.628c-.037,0-.037.056,0,.075a2.077,2.077,0,0,1,1.666,1.628c0,.037.075.037.075,0a2.077,2.077,0,0,1,1.666-1.628C45.922,66.044,45.922,65.988,45.884,65.988ZM74.705,90.159a.636.636,0,1,0,.636.636A.636.636,0,0,0,74.705,90.159Z",
    transform: "translate(-36.73 -52.292)",
    fill: "#f5c84c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42364",
    "data-name": "Path 42364",
    d: "M64.036,43.332a.636.636,0,1,0,.636.636.636.636,0,0,0-.636-.636Z",
    transform: "translate(-53.759 -35.223)",
    fill: "#87d147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42365",
    "data-name": "Path 42365",
    d: "M56.709,186.2a.554.554,0,0,1,.558-.541h1.183a.791.791,0,0,1-.791-.791v-9.045l-1.6.4a2.668,2.668,0,0,0-2.013,2.439l-.373,6.43a1.6,1.6,0,0,1,.9,1.438v1.394H58.42A1.711,1.711,0,0,1,56.709,186.2Zm20.037,1.728h4.912l-.537-9.262a2.668,2.668,0,0,0-2.013-2.439l-1.6-.4v9.045a.791.791,0,0,1-.791.791H77.9a.554.554,0,0,1,.558.541,1.711,1.711,0,0,1-1.711,1.727Z",
    transform: "translate(-45.852 -142.919)",
    fill: "#70d6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42366",
    "data-name": "Path 42366",
    d: "M105.393,74.563a.362.362,0,0,0-.349-.355,7.039,7.039,0,0,1-4.858-1.753.364.364,0,0,0-.541.034A7.329,7.329,0,0,1,92.307,74.9a.361.361,0,0,0-.436.349v5.444A6.779,6.779,0,0,0,95.5,86.679h6.26a6.779,6.779,0,0,0,3.631-5.986V74.669C105.394,74.634,105.394,74.6,105.393,74.563Z",
    transform: "translate(-76.902 -58.81)",
    fill: "#f9d0b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42367",
    "data-name": "Path 42367",
    d: "M95.356,40.663c0-.167.009-.331.023-.494a3.78,3.78,0,0,0-2.963.417,3.866,3.866,0,0,0-3.312-1.89H87.121a7,7,0,0,0-6.979,6.979V48.8a2.809,2.809,0,0,1,2.2-.584v-.325a.361.361,0,0,1,.436-.349,7.329,7.329,0,0,0,7.338-2.411.364.364,0,0,1,.541-.034,7.039,7.039,0,0,0,4.858,1.753.362.362,0,0,1,.349.355c0,.035,0,.07,0,.106v.9a2.8,2.8,0,0,1,2.392.758v-3.53C98.366,43.824,97.813,41.09,95.356,40.663Z",
    transform: "translate(-67.368 -31.453)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42368",
    "data-name": "Path 42368",
    d: "M74.778,89.388a2.833,2.833,0,0,0-.434.034v5.119c0,.153-.007.3-.017.453a2.822,2.822,0,1,0,.451-5.607ZM60.821,94.541V89.422a2.824,2.824,0,1,0,.017,5.572h0Q60.822,94.768,60.821,94.541Zm15.924,23.128h4.912l-.208-3.582H77.506v.523a.791.791,0,0,1-.791.791H77.9a.554.554,0,0,1,.558.541,1.711,1.711,0,0,1-1.711,1.728Zm-20.037-1.728a.554.554,0,0,1,.558-.541h1.183a.791.791,0,0,1-.791-.791v-.523H53.716l-.044.751a1.6,1.6,0,0,1,.9,1.438v1.394H58.42a1.711,1.711,0,0,1-1.711-1.728Z",
    transform: "translate(-45.852 -72.659)",
    fill: "#f9d0b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42369",
    "data-name": "Path 42369",
    d: "M121.158,123.1a.468.468,0,0,0-.659.058,2.066,2.066,0,0,1-2.947,0,.468.468,0,0,0-.717.6,3,3,0,0,0,4.381,0,.468.468,0,0,0-.058-.659Z",
    transform: "translate(-97.105 -99.976)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_522",
    "data-name": "Ellipse 522",
    cx: 0.863,
    cy: 0.863,
    rx: 0.863,
    ry: 0.863,
    transform: "translate(23.864 19.047)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_523",
    "data-name": "Ellipse 523",
    cx: 0.863,
    cy: 0.863,
    rx: 0.863,
    ry: 0.863,
    transform: "translate(18.069 19.047)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42370",
    "data-name": "Path 42370",
    d: "M79.6,92.5a3.122,3.122,0,0,0-2.366-2.867l-1.422-.358a.468.468,0,0,0-.229.907L77,90.539a2.192,2.192,0,0,1,1.66,2.012l.527,9.091a.468.468,0,0,0,.934-.054ZM55.948,89.611a.468.468,0,0,0-.568-.339l-1.428.359A3.122,3.122,0,0,0,51.587,92.5l-.363,6.267a.468.468,0,1,0,.934.054l.364-6.269a2.191,2.191,0,0,1,1.66-2.011l1.428-.359a.468.468,0,0,0,.339-.568ZM72.82,72.521a.829.829,0,0,0-.8-.814,6.612,6.612,0,0,1-4.544-1.62.832.832,0,0,0-1.235.077,6.81,6.81,0,0,1-6.876,2.244.831.831,0,0,0-.7.169.822.822,0,0,0-.3.642v5.439a7.239,7.239,0,0,0,3.789,6.353.468.468,0,0,0,.448-.822,6.3,6.3,0,0,1-3.3-5.531V73.35a7.828,7.828,0,0,0,7.6-2.516,7.507,7.507,0,0,0,4.985,1.8v6.02a6.3,6.3,0,0,1-3.3,5.531.468.468,0,0,0,.448.822,7.24,7.24,0,0,0,3.789-6.353V72.636Q72.821,72.578,72.82,72.521Z",
    transform: "translate(-43.861 -56.777)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42371",
    "data-name": "Path 42371",
    d: "M93.333,37.647a4.329,4.329,0,0,0-2.8.3A4.354,4.354,0,0,0,87.072,36.2H85.088a7.456,7.456,0,0,0-7.447,7.447v2.982a.468.468,0,1,0,.936,0V43.643a6.519,6.519,0,0,1,6.511-6.511h1.983a3.417,3.417,0,0,1,2.911,1.663.468.468,0,0,0,.642.161,3.4,3.4,0,0,1,2.5-.4.468.468,0,1,0,.212-.911Zm-.442.911a4.372,4.372,0,0,1,2.861,2.719c.722,2.174,0,5.533,0,5.533a.468.468,0,0,0,.936,0s.722-3.792,0-5.965a5.8,5.8,0,0,0-3.2-3.109C93.486,37.478,92.891,38.3,92.891,38.558Z",
    transform: "translate(-65.335 -29.422)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42372",
    "data-name": "Path 42372",
    d: "M73.582,86.889q-.137,0-.271.012a.468.468,0,0,0,.079.933q.1-.008.192-.008a2.355,2.355,0,1,1,0,4.71,2.035,2.035,0,0,1-.214-.012.468.468,0,0,0-.1.931,3,3,0,0,0,.31.016,3.291,3.291,0,0,0,0-6.582ZM59.371,92.527q-.09.008-.18.008a2.355,2.355,0,1,1,0-4.71c.062,0,.123,0,.184.008a.468.468,0,0,0,.076-.933c-.086-.007-.172-.011-.26-.011a3.291,3.291,0,1,0,0,6.582c.089,0,.177,0,.264-.012a.468.468,0,1,0-.084-.932Zm20.664,19.061h-3.66a.468.468,0,0,0,0,.936h3.66a.468.468,0,0,0,0-.936Zm-23.753,0H52.669a.468.468,0,0,0,0,.936h3.614a.468.468,0,0,0,0-.936Z",
    transform: "translate(-44.656 -70.628)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42381",
    "data-name": "Path 42381",
    d: "M28.856,222H26.068A2.071,2.071,0,0,0,24,224.068v1.394a.468.468,0,0,0,.468.468h5.989a.468.468,0,0,0,.468-.468v-1.394A2.071,2.071,0,0,0,28.856,222Zm1.133,2.994H24.936v-.926a1.134,1.134,0,0,1,1.133-1.133h2.788a1.134,1.134,0,0,1,1.133,1.133Z",
    transform: "translate(-21.733 -180.453)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42374",
    "data-name": "Path 42374",
    d: "M91.088,228.377H70.457a.558.558,0,0,0-.558.558,1.711,1.711,0,0,0,1.711,1.711H89.936a1.711,1.711,0,0,0,1.711-1.711.558.558,0,0,0-.558-.558Z",
    transform: "translate(-59.042 -185.636)",
    fill: "#dae6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42378",
    "data-name": "Path 42378",
    d: "M178.3,39.689a.68.68,0,0,0-.962,0l-1.091,1.091-.547-.547a.68.68,0,1,0-.962.962l1.028,1.028a.68.68,0,0,0,.962,0l1.572-1.572A.68.68,0,0,0,178.3,39.689Z",
    transform: "translate(-141.688 -31.381)",
    fill: "#70d6f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42397",
    "data-name": "Path 42397",
    d: "M94.032,148.91H75.766a.791.791,0,0,0-.791.791v13.291a.791.791,0,0,0,.791.791H94.032a.791.791,0,0,0,.791-.791V149.7a.791.791,0,0,0-.791-.791Z",
    transform: "translate(-63.168 -121.042)",
    fill: "#edf4fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42375",
    "data-name": "Path 42375",
    d: "M121.522,186.144h-2.66a.468.468,0,1,0,0,.936h2.66a.468.468,0,1,0,0-.936Z",
    transform: "translate(-98.461 -151.307)",
    fill: "#1b2737"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_42395",
    "data-name": "Path 42395",
    d: "M89.056,225.877H68.425A1.027,1.027,0,0,0,67.4,226.9a2.181,2.181,0,0,0,2.179,2.179H87.9a2.181,2.181,0,0,0,2.179-2.179A1.027,1.027,0,0,0,89.056,225.877ZM87.9,228.146H69.578a1.244,1.244,0,0,1-1.243-1.243.09.09,0,0,1,.09-.09H89.056a.09.09,0,0,1,.09.09A1.244,1.244,0,0,1,87.9,228.146Z",
    transform: "translate(880.491 252.188)",
    fill: "#1b2737"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42396",
    "data-name": "Path 42396",
    d: "M92,146.41H73.733a1.26,1.26,0,0,0-1.258,1.258V160.96a1.26,1.26,0,0,0,1.258,1.258H92a1.26,1.26,0,0,0,1.258-1.258V147.668A1.26,1.26,0,0,0,92,146.41Zm.323,14.55a.323.323,0,0,1-.323.323H73.733a.323.323,0,0,1-.323-.323V147.668a.323.323,0,0,1,.323-.323H92a.323.323,0,0,1,.323.323V160.96Z",
    transform: "translate(876.365 316.782)",
    fill: "#1b2737"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.9f8f78567468202063aa8b70cf08bc93.svg";
export { ForwardRef as ReactComponent };